import React from 'react';
import './RecentTable.css'

const RTableRow = (props) => {
    return ( 
        <div className='RTableRow'>
            <div className='RTableText'>
                <p className='RowName'>
                    {props.RowName}
                </p>
                <p className='RowSub'>
                    {props.RowSub}
                </p>
            </div>
            <div className='RTableInfo'>
                <p className='RowPrice'>
                    {props.RowInfo}
                </p>
                <p className={props.RowTag}>
                    {props.RowTag}
                </p>
            </div>
        </div>
     );
}
 
export default RTableRow;